import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export const BooleanIndicator = (props: { value?: boolean }) =>
    props.value === undefined
        ? null
        : props.value === true
            ? <FontAwesomeIcon icon="check" className="text-success" />
            : <FontAwesomeIcon icon="times" className="text-danger" />;